import mapboxgl, { MapboxGeoJSONFeature, MapBoxZoomEvent } from "mapbox-gl";
import { useEffect } from "react";
import { MapboxSources } from "../../../mapbox";
import { Dict } from "../useDict";
import { allMapboxSourceIds, groupFeaturesBySource } from "./util";

interface UseDragSelectionHandlerProps {
  map: mapboxgl.Map | null;
  mapboxSources: Dict<MapboxSources>;
  setUniqueSelectedFeatures: (
    featuresByMapboxSource: Dict<MapboxGeoJSONFeature[]>
  ) => void;
}

export default function useDragSelectionHandler(
  props: UseDragSelectionHandlerProps
): void {
  const { map, mapboxSources, setUniqueSelectedFeatures } = props;

  useEffect(() => {
    if (map == null) return;

    let dragStart: mapboxgl.Point;

    const sourceIds = allMapboxSourceIds(mapboxSources);

    const boxZoomStartHandler = (evt: MapBoxZoomEvent) => {
      dragStart = new mapboxgl.Point(evt.originalEvent.x, evt.originalEvent.y);
    };

    const boxZoomEndHandler = (evt: MapBoxZoomEvent) => {
      map.stop(); // Prevent the default Mapbox zoom behaviour

      const dragEnd = new mapboxgl.Point(
        evt.originalEvent.x,
        evt.originalEvent.y
      );

      const features = map
        .queryRenderedFeatures([dragStart, dragEnd])
        .filter(feature => sourceIds.includes(feature.source));

      const grouped = groupFeaturesBySource(features);

      setUniqueSelectedFeatures(grouped);
    };

    map.on("boxzoomstart", boxZoomStartHandler);
    map.on("boxzoomend", boxZoomEndHandler);

    return () => {
      map.off("boxzoomstart", boxZoomStartHandler);
      map.off("boxzoomend", boxZoomEndHandler);
    };
  }, [map, mapboxSources, setUniqueSelectedFeatures]);
}
